export function FormatChips({ listing }) {
  const stl = listing.has_stl ?? (listing.file_type === "stl" || !listing.editable);
  const dm = listing.has_3dm ?? listing.editable;
  // Solid-fill, high-contrast badges. Buyers were missing the outline
  // version — now STL is slate-solid + 3DM is emerald-solid with white
  // text and heavier font weight so they read at a glance on any card.
  return (
    <div className="flex gap-1.5" data-testid="format-chips">
      {stl && (
        <span className="inline-flex items-center gap-1.5 font-mono text-[11px] tracking-widest uppercase px-2.5 py-1 rounded font-bold bg-slate-700 text-white shadow-sm">
          <span className="h-1.5 w-1.5 rounded-full bg-white" /> STL · Print
        </span>
      )}
      {dm && (
        <span className="inline-flex items-center gap-1.5 font-mono text-[11px] tracking-widest uppercase px-2.5 py-1 rounded font-bold bg-emerald-600 text-white shadow-sm">
          <span className="h-1.5 w-1.5 rounded-full bg-white" /> 3DM · Editable
        </span>
      )}
    </div>
  );
}


export function FormatBadge({ editable }) {
  return (
    <span
      data-testid="format-badge"
      className={`inline-flex items-center gap-1.5 font-mono text-[11px] tracking-widest uppercase px-2.5 py-1 rounded font-bold text-white shadow-sm ${
        editable ? "bg-emerald-600" : "bg-slate-700"
      }`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-white" />
      {editable ? "Editable · 3DM" : "Print-Ready · STL"}
    </span>
  );
}

export function Spec({ label, value }) {
  return (
    <div className="flex flex-col">
      <span className="text-[10px] uppercase tracking-widest text-muted-foreground">{label}</span>
      <span className="font-mono text-sm text-foreground">{value}</span>
    </div>
  );
}
